<script>
export default {
  name: "EmptyState",
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: "",
    },
    link: {
      type: Object,
      default: () => null,
    },
    buttonText: {
      type: String,
      default: "",
    },
    buttonPath: {
      type: String,
      default: "",
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <eg-b-row class="text-center">
    <eg-b-col class="m-auto empty-state">
      <slot></slot>
      <h1 :class="{ 'mt-5': true, h5: true, 'heading-s': true }">
        {{ title }}
      </h1>
      <p
        v-if="description || $slots.descriptionSlot"
        class="paragraph-m description"
      >
        <slot name="descriptionSlot">
          {{ description }}
        </slot>
      </p>
      <router-link v-if="link" :to="link.to" class="box-title">
        <div class="text-truncate mb-0">
          {{ link.text }}
        </div>
      </router-link>

      <slot name="buttons">
        <eg-b-button
          v-if="buttonText && buttonPath"
          :to="buttonPath"
          variant="info"
        >
          {{ buttonText }}
        </eg-b-button>
      </slot>
    </eg-b-col>
  </eg-b-row>
</template>

<style lang="scss" scoped>
.empty-state {
  max-width: 535px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  h1 {
    font-family: "Inter", sans-serif;
    margin-bottom: 0.5rem;
  }

  .description {
    color: var(--color-text-neutral-secondary);
    font-weight: var(--typography-font-weight-fw-400);
  }
}
</style>
